import { DataService } from "../../../../Autofacets-Core/src/app/services/data.service";
import { GenericResponse } from "../../../../Autofacets-Core/src/app/business-entities/generic-response.class";
import { CustomerDetailsViewModel, CustomerModel, DuplicateCustomerRequestModel } from "../business-entities/customer-view.model";
import { CustomerDealerAssociationResponseModel } from "../business-entities/customer-dealer-association-response-model.model";
import { Urls } from "../../../../Autofacets-Core/src/app/utils/urls";
import { Injectable } from "@angular/core";
import { CustomerListRequestModel } from "../business-entities/customerList-request-model";

@Injectable({
    providedIn: 'root'
})

export class CustomerDataService {
    constructor(private dataProvider: DataService) {
    }

    async getCustomerList(requestModel: CustomerListRequestModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetCutomerList, requestModel).toPromise();
    }

    async GetCustomerPrivacyLogById(id: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCustomerPrivacyLogById, id).toPromise();
    }

    async CheckCustomerDuplication(model:any): Promise<GenericResponse<any>>
    {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CheckCustomerDuplication,model).toPromise();
    }

    async getCustomerById(id: number): Promise<GenericResponse<CustomerDetailsViewModel>> {
        return this.dataProvider.Get<GenericResponse<CustomerDetailsViewModel>>
            (Urls.GetCustomerById, id).toPromise();
    }

    async getCustomerDealerAssociationById(id: number): Promise<GenericResponse<CustomerDealerAssociationResponseModel>> {
        return this.dataProvider.Get<GenericResponse<CustomerDealerAssociationResponseModel>>
            (Urls.GetCustomerDealerAssociation, id).toPromise();
    }

    async addCustomerDiscount(model: any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddCustomerDiscount, model).toPromise();
    }

    async AddEditCustomer(customerInfo: CustomerModel): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddEditCustomer, customerInfo).toPromise();
    }

    async crmAddEditCustomer(customerInfo: any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CrmAddEditCustomer, customerInfo).toPromise();
    }

    async GetCustomerGroupDropdown(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetCustomerGroupDropdown).toPromise();
    }

    async GetAddressSalutationDropdown(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetAddressSalutationDropdown).toPromise();
    }

    async GetPostCodeDropdown(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetPostCodeDropdown).toPromise();
    }

    getCountryCodeAndMobileCodeDetails(): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCountryCodeAndMobileCodeDetails).toPromise();
    }

    async CheckDuplicateCustomer(customerInfo: DuplicateCustomerRequestModel): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CheckDuplicateCustomer, customerInfo).toPromise();
    }

    async ResyncCustomer(id: number, moduleId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>
            (Urls.ResyncCustomer, id, moduleId).toPromise();
    }
    async getDFCustomerListByFullSearch(search: string): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.getDFCustomerListByFullSearch, search).toPromise();
    }
    async getDFCustomerListByAdvanceSearch(advanceSearchRequest: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.getDFCustomerListByAdvanceSearch,advanceSearchRequest).toPromise();
    }     
    async getEMCustomerListByAdvanceSearch(advanceSearchRequest: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.getEMCustomerListByAdvanceSearch,advanceSearchRequest).toPromise();
    } 
    async getAccountsAutoComplete(searchTerm: string): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.getAccountsSearchTerm, searchTerm).toPromise(); 
    }
    async GetCallHistoryList(model: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetCallHistoryList, model).toPromise(); 
    }
    async getCustomerDropdownByLicensePlateNo(licensePlateNo: string,apponitmentId:number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCustomerDropdownByLicensePlateNo, licensePlateNo,apponitmentId).toPromise();
    }
    async HarddeleteCustomer(model: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.HardDeleteCustomer, model).toPromise(); 
    }
    async getCustomerUpdateHistory(customerGuid:string): Promise<GenericResponse<any>>{
        return await this.dataProvider.Get<GenericResponse<any>>(Urls.GetCustomerHistory,customerGuid).toPromise();
    }
}